interface Props {
  channelTitle?: string
  subscribers?: number | null
  er?: number | null
  period: 'day' | 'week' | 'month' | 'quarter'
  onPeriodChange: (period: 'day' | 'week' | 'month' | 'quarter') => void
  updatedAgo?: string
}

const PERIODS: Array<{ key: 'day' | 'week' | 'month' | 'quarter'; label: string }> = [
  { key: 'day', label: 'День' },
  { key: 'week', label: 'Неделя' },
  { key: 'month', label: '30 дней' },
  { key: 'quarter', label: '90 дней' },
]

export function DashboardHero({ channelTitle, subscribers, er, period, onPeriodChange, updatedAgo }: Props) {
  const subText =
    subscribers !== undefined && subscribers !== null
      ? subscribers.toLocaleString('ru-RU')
      : '—'
  const erText = er !== undefined && er !== null ? er.toString().replace('.', ',') : '—'

  return (
    <div className="hero">
      <div>
        <p className="hero-eyebrow">
          <span className="hero-eyebrow-dot" />
          {updatedAgo || 'Данные обновлены сейчас'}
        </p>
        <h1 className="hero-title">
          Добро пожаловать. <em>Вот ваш канал</em>
        </h1>
        <p className="hero-meta">
          {channelTitle || '—'} · MAX · подписчиков <b>{subText}</b>
          {er !== null && er !== undefined && <> · ER <b>{erText} %</b></>}
        </p>
      </div>
      <div className="period-tabs">
        {PERIODS.map((p) => (
          <button
            key={p.key}
            className={p.key === period ? 'on' : ''}
            onClick={() => onPeriodChange(p.key)}
          >
            {p.label}
          </button>
        ))}
      </div>

      <style>{`
        .hero {
          display: grid;
          grid-template-columns: 1fr auto;
          gap: 24px;
          align-items: end;
          margin-bottom: 24px;
        }
        @media (max-width: 768px) {
          .hero {
            grid-template-columns: 1fr;
          }
        }
        .hero-eyebrow {
          font-weight: 700;
          font-size: 11px;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: var(--tg-mute, #8f9eb0);
          margin: 0 0 8px;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .hero-eyebrow-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #00b86b;
          box-shadow: 0 0 0 4px rgba(0, 168, 96, 0.16);
          animation: tg-pulse-dot 2s ease-in-out infinite;
        }
        @keyframes tg-pulse-dot {
          0%, 100% { box-shadow: 0 0 0 4px rgba(0, 168, 96, 0.16); }
          50% { box-shadow: 0 0 0 8px rgba(0, 168, 96, 0.05); }
        }
        .hero-title {
          font-weight: 800;
          font-size: 36px;
          line-height: 1.05;
          letter-spacing: -0.025em;
          color: var(--tg-ink, #111);
          margin: 0 0 8px;
        }
        .hero-title em {
          font-family: 'Instrument Serif', serif;
          font-style: italic;
          font-weight: 400;
          color: var(--tg-blue, #0080ff);
          letter-spacing: 0;
          font-size: 0.94em;
        }
        .hero-meta {
          font-size: 14px;
          color: var(--tg-mute, #8f9eb0);
          font-weight: 500;
          margin: 0;
        }
        .hero-meta b {
          color: var(--tg-ink-2, #333);
          font-weight: 600;
        }

        .period-tabs {
          display: flex;
          background: var(--tg-surface, #fff);
          padding: 4px;
          border-radius: 10px;
          border: 1px solid var(--tg-line-2, #f0f0f4);
        }
        .period-tabs button {
          font-family: inherit;
          font-weight: 600;
          font-size: 13px;
          padding: 7px 14px;
          background: transparent;
          color: var(--tg-mute, #8f9eb0);
          border: 0;
          border-radius: 7px;
          cursor: pointer;
          font-variant-numeric: tabular-nums;
          transition: background 150ms, color 150ms;
        }
        .period-tabs button:hover {
          color: var(--tg-ink-2, #333);
        }
        .period-tabs button.on {
          background: var(--tg-ink, #111);
          color: white;
        }
      `}</style>
    </div>
  )
}
